import a from "axios";

const axios = a.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api/v1",
});

export { axios };
